/* ##################################################################### */
/* Trade Management Supabase Module */
/* ##################################################################### */

// Supabase Configuration
export const SUPABASE_URL =
  window.VI_DEV?.SUPABASE_URL || "https://qlatmxlkguxukobkjpop.supabase.co";
export const SUPABASE_ANON_KEY =
  window.VI_DEV?.SUPABASE_ANON_KEY ||
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFsYXRteGxrZ3V4dWtvYmtqcG9wIiwicm9sZSI6ImFub24iLCJpYXQiOjE3Mzc0ODUzNTksImV4cCI6MjA1MzA2MTM1OX0.gD9VuJWtYVqVEuMhvtEncJmeMkajOzsCGCdIpum8_As";

export class SupabaseManager {
  constructor() {
    this.supabase = null;
    this.realtimeSubscription = null;
  }

  init(createClient) {
    if (!createClient) {
      console.error("Supabase client not loaded");
      return false;
    }

    try {
      // Initialize Supabase client with environment variables
      this.supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
        auth: {
          persistSession: false, // Since this is an internal tool
        },
        realtime: {
          params: {
            eventsPerSecond: 10,
          },
        },
      });

      return true;
    } catch (error) {
      console.error("Failed to initialize Supabase client:", error);
      return false;
    }
  }

  async testConnection() {
    try {
      // Test REST API connection first
      const { data, error } = await this.supabase
        .from("trades")
        .select("id")
        .limit(1);

      if (error) throw error;

      // If REST API works, initialize realtime
      if (this.realtimeSubscription) {
        await this.realtimeSubscription.unsubscribe();
      }

      return true;
    } catch (error) {
      console.error("Connection test failed:", error);
      throw error;
    }
  }

  async fetchTraders() {
    try {
      const { data, error } = await this.supabase
        .from("traders")
        .select("id, name")
        .order("name");

      if (error) throw error;
      return data;
    } catch (error) {
      console.error("Error loading traders:", error);
      throw error;
    }
  }

  async fetchProducts() {
    try {
      const { data, error } = await this.supabase
        .from("products")
        .select("*")
        .order("name");

      if (error) throw error;
      return data;
    } catch (error) {
      console.error("Error loading products:", error);
      throw error;
    }
  }

  async fetchPortfolioFractions() {
    try {
      const { data, error } = await this.supabase
        .from("portfolio_fractions")
        .select("*")
        .order("size");

      if (error) throw error;
      return data;
    } catch (error) {
      console.error("Error loading portfolio fractions:", error);
      throw error;
    }
  }

  getClient() {
    return this.supabase;
  }
}

// Create and export the SupabaseManager instance
const supabaseManager = new SupabaseManager();
export { supabaseManager };
